import { twMerge } from 'tailwind-merge';

import { Paths } from '@/utils/paths';

import { Link, LinkProps } from '../../Link';

import { NetworkCardContextProvider } from './network-card-context';

export type RootProps = Omit<LinkProps, 'href'> & {
  network: AdaptedNetwork;
};

export function Root({ network, className, ...props }: RootProps) {
  const networkProfileHref = `${Paths.NETWORK_GIFTCARDS}/${network.slug}`;

  return (
    <NetworkCardContextProvider network={network}>
      <Link
        className={twMerge(
          'flex flex-col gap-3 rounded-md bg-white px-4 pb-8 shadow-xl lg:gap-6',
          'hover:ring-network-primary ring-2 ring-transparent',
          'transition-colors',
          className,
        )}
        variant="ghost"
        href={networkProfileHref}
        {...props}
      />
    </NetworkCardContextProvider>
  );
}
